module.exports = __webpack_public_path__ + "static/media/gameover.cef7e56.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/gameover.wav
// module id = 152
// module chunks = 1